export class Validation {
  public static readonly windowsFileNameRegex = /[/*?";@,:[\]|<>\\]/g;

  public static sanitizedWindowsFileName = (fileName: string) => fileName.replace(Validation.windowsFileNameRegex, '');

  public static isNotValid = (element: ng.INgModelController) =>
    Validation.isValidationEnabled(element) && Validation.hasError(!element.$valid);

  public static isNotValidOrEmpty = (element: ng.INgModelController) => {
    let result = Validation.isValidationEnabled(element) && Validation.hasError(!element.$valid);

    if (element.$isEmpty(element.$modelValue)) {
      result = true;
    }

    return result;
  };

  /**
   * Determines if the element is empty
   *
   * @param element The element to consider.
   * @return True if the value in the element is empty, false otherwise.
   */
  public static isEmpty = (element: ng.INgModelController) => {
    const result = element.$isEmpty(element.$viewValue);
    return result;
  };

  /**
   * Determines if validation is enabled for the specified element.
   *
   * The dirty and touched states of the specified element are taken into consideration.
   *
   * @param element The element to consider.
   * @return True if validation is enabled, false otherwise.
   */
  public static isValidationEnabled = (element: ng.INgModelController): boolean => element.$dirty || element.$touched;

  /**
   * Returns true if any of the supplied arguments is truthy (expects objects that represent an error).
   * This will only be evaluated if the controller has been initialized.
   *
   * @param args Variable list of arguments to check.
   * @return True if any of the supplied arguments are truthy.
   */
  public static hasError = (...args: any[]): boolean => {
    let error = false;

    for (const arg of args) {
      error = error || arg;
    }

    return error;
  };
}
